import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {  MsalService } from '@azure/msal-angular';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { map, Observable } from 'rxjs';
import jwt_decode from 'jwt-decode';
import { CommonService } from 'src/app/shared/services/common.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../services/auth.service';
import { Roles } from 'src/app/shared/services/names.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  welcomeMessage!: string;
  username!: any;
  showLogoutButton!: boolean;
  showGetAccountsButton!: boolean;
  accounts: any;
  showAccountsTable!: boolean;
  selectedLang: any = 'en';


  constructor(private msalService: MsalService, public transService: TranslationService,
    private authService:AuthService,
    private translate:TranslateService,
    private http: HttpClient, private router: Router, private commonService: CommonService) { }

  ngOnInit(): void {
    const authToken = localStorage.getItem('authToken')
    this.selectedLang =  this.translate.currentLang?this.translate.currentLang:'en'
    if(this.selectedLang == "ar"){
      this.lan("ar")
    }
    if (authToken)
      this.navigateToDashboard()
  }

  lan(value: any) {
    this.transService.setLanguage(value)
    
    this.selectedLang = value
    localStorage.setItem('language', value)
    // window.location.reload()

    const direction = document.querySelector('html')
    if (this.selectedLang == 'ar') {
      direction!.setAttribute('dir', 'rtl')
    } else {
      direction!.setAttribute('dir', 'ltr')
    }
  }

  signIn() {
    this.msalService.loginPopup({
      scopes: ['User.Read', `${environment.domain}/user_impersonation`]
    })
      .subscribe({
        next: async (result: any) => {
          if (result !== null) {
            this.username = result.account.username;
            this.msalService.instance.setActiveAccount(result.account)
            let userDetails: any = jwt_decode(result.accessToken)
            localStorage.setItem('loggedinUser', JSON.stringify(userDetails))
            localStorage.setItem('authToken', result.accessToken)
            localStorage.setItem('uniqueId',result.uniqueId)
            this.navigateToDashboard()
          } else {
            this.selectAccount();
          }
        },
        error: (error) => {
          console.error('Error during MSAL redirect: ', error);
        },
      })
  }

  async navigateToDashboard(){
    let userRoles = await this.authService.getUserRoles()
    if(userRoles === Roles.adminUser || userRoles === Roles.cprUser){
    this.router.navigate(['/app/dashboard']);
      localStorage.setItem("activeDashboard",Roles.cprUser)
    }else{
      this.router.navigate(['/app/dashboard/mkt']);
      localStorage.setItem("activeDashboard",Roles.mktUser)
    }
  }

  private selectAccount() {
    const currentAccounts = this.msalService.instance.getAllAccounts();
    if (currentAccounts.length === 1) {
      const username = currentAccounts[0].username;
      this.showWelcomeMessage(username);
    }
  }
  private showWelcomeMessage(username: string) {
    this.welcomeMessage = `Welcome ${username}`;
    this.showLogoutButton = true;
    this.showGetAccountsButton = true;
  }

}
